module.exports = __webpack_public_path__ + "static/img/12012D_11_12_R_20190811_LC.ea72c50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12012D_11_12_R_20190811_LC.png
// module id = O65A
// module chunks = 0